<div class="circle-icon orange">
  <app-svg src="/assets/icons/alert-circle.svg"></app-svg>
</div>

<div class="content">
  <div class="title">{{ title() }}</div>
  <div class="message">{{ message() }}</div>
</div>
<button
  appButton
  name="add-password"
  location="change-email-dialog"
  color="orange"
  (click)="onClick.emit()"
  shape="round"
  weight="bold"
  height="1"
  spacing="3"
>
  {{ ctaText() }}
</button>
